/* eslint-disable no-throw-literal */
import { put, call } from 'redux-saga/effects';
import {
    GESTION_OPERATIVA_GET_PERITAJE_BEGIN,
    GESTION_OPERATIVA_GET_PERITAJE_SUCCESS,
    GESTION_OPERATIVA_GET_PERITAJE_FAILURE,
    GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR
  } from '../constants'
  import { BFFAgent } from '../../../../common/BFFAgent'
import { PATENTE_LOCKED } from 'presupuestador/lib/constants';

export default function* getPeritajeSaga({data: { patente, verPeritaje, usados, isCurrent, status } }) {
  try {
      yield put({
        type: GESTION_OPERATIVA_GET_PERITAJE_BEGIN,
      })
        const peritajeResp =  yield call(BFFAgent.Peritador.getPeritaje ,patente, verPeritaje, isCurrent, status);
        const peritaje = peritajeResp.peritaje
        const peritajeQuote = peritajeResp.peritajeQuote
        const peritajeQuoteVerification = peritajeQuote?.verification
        let takingCar = null;

        const {locked} = yield call (BFFAgent.Peritador.getLockedPatent, patente)

        if (locked) {
          throw {
            type: 'bloqued',
            message: PATENTE_LOCKED,
          }
        }

        // Estructura del peritaje para guardar en el estado global de Redux
        // Obtenemos las peritaciones del estado global y añadimos el nuevo peritaje

        if (!peritaje) {
          throw{
            type: 'noPeritado', 
            message: 'La patente no está peritada'
          }
        }
                  
        // Estructura del Vehiculo usado para devolver dentro de la respuesta de la acción
        if(peritajeQuote){
          let statusId = peritajeQuoteVerification.statusId
          if(verPeritaje) {
            switch(peritajeQuoteVerification.statusId){
              case "6":
                if (peritaje.recepcion_manual || peritaje.presupuesto_reservado) {
                  statusId = null
                } 
              break;
              case "9":
                statusId = null
              break;
              case "11":
                statusId = null
              break;
              default:  
                statusId = peritajeQuoteVerification.statusId 
            }
          }
            takingCar = {
              appraisal: peritajeQuote.appraisal,
              final_take_price: peritajeQuote.appraisal,
              precio: peritajeQuote.final_take_price,
              original_price: peritajeQuote.appraisal,
              appraisal_approved: peritajeQuote.appraisal_approved,
              use_take_improvement: false, // -->agregar con feature mejora precio
              take_improvement_amount: 0, // -->agregar con feature mejora precio
              taking_auth_id:'',
              quotation_id: peritajeQuote.requestsId,
              year: peritajeQuoteVerification?.vehicle.year.label,
              brand: peritajeQuoteVerification?.vehicle.brand.label,
              model: peritajeQuoteVerification?.vehicle.model.label,
              version: peritajeQuoteVerification?.vehicle.version.label,
              version_id: peritajeQuoteVerification?.vehicle.version.value,
              license_plate: peritajeQuoteVerification?.licencePlate,
              mileage: peritajeQuoteVerification?.kilometraje,
              assessed: statusId,
              assessmentDate: peritaje.modificationDate,
              requestsId: peritaje.id
          }
      }
          yield put({
            type: GESTION_OPERATIVA_GET_PERITAJE_SUCCESS,
            data: { peritaje, peritajeQuoteVerification },
          })

          yield put({
            type: GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR,
            data: {takingCar, isModified: true}
          })
    } catch (e) {
        yield put({
          type: GESTION_OPERATIVA_GET_PERITAJE_FAILURE,
          data: 
            { 
              code: e.type,
              message: usados ? e.message : null
            }
        })
      }
  }
